
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Seo from "../components/Seo";

import {
    Clock,
    Tv,
    Smartphone,
    Monitor,
    CheckCircle2,
    Play,
    ShieldCheck,
    Zap,
    Headphones,
    ChevronDown,
    ArrowRight,
    Wifi,
    Film,
    CalendarDays,
    MessageCircle,
} from "lucide-react";

const faqs = [
    {
        question: "L'essai IPTV est-il vraiment gratuit ?",
        answer:
            "Notre offre d'essai est proposée pendant 24 heures. Contactez notre équipe pour connaître les conditions d'accès et les éventuelles restrictions.",
    },
    {
        question: "Combien de temps dure l'essai IPTV ?",
        answer:
            "La période d'essai dure 24 heures à partir de l'activation de vos accès.",
    },
    {
        question: "Dois-je souscrire un abonnement après le test ?",
        answer:
            "Non. L'essai vous permet de découvrir le service avant de prendre une décision. Vous pouvez comparer les formules disponibles avant toute souscription.",
    },
    {
        question: "Puis-je tester le service sur ma Smart TV ?",
        answer:
            "Oui, si votre téléviseur prend en charge une application compatible. La compatibilité dépend de la marque et du système d'exploitation de votre appareil.",
    },
    {
        question: "Quels appareils sont compatibles avec IPTV ?",
        answer:
            "Le service peut être utilisé sur différents appareils compatibles : Smart TV, Android TV, Fire TV Stick, smartphones, tablettes et ordinateurs.",
    },
    {
        question: "Quelle connexion Internet faut-il pour utiliser IPTV ?",
        answer:
            "Une connexion Internet stable est recommandée. Le débit nécessaire dépend de la qualité vidéo, de votre appareil et de votre utilisation.",
    },
    {
        question: "Comment obtenir mon essai IPTV en France ?",
        answer:
            "Contactez notre équipe depuis la page Contact pour demander votre période d'essai et recevoir les informations nécessaires à la configuration.",
    },
];

const features = [
    {
        icon: Tv,
        title: "Chaînes en direct",
        description:
            "Découvrez les chaînes disponibles dans votre formule et testez leur qualité de diffusion.",
    },
    {
        icon: Film,
        title: "Films et séries",
        description:
            "Explorez le catalogue de contenus à la demande et découvrez les différentes catégories.",
    },
    {
        icon: Zap,
        title: "Qualité de streaming",
        description:
            "Testez les qualités de diffusion disponibles selon votre connexion et votre appareil.",
    },
    {
        icon: CalendarDays,
        title: "Guide des programmes",
        description:
            "Consultez les informations des programmes grâce au guide électronique, lorsqu'il est disponible.",
    },
];

const devices = [
    { icon: Tv, name: "Smart TV", detail: "Téléviseurs compatibles" },
    { icon: Monitor, name: "Android TV", detail: "Téléviseurs Android" },
    { icon: Play, name: "Fire TV Stick", detail: "Appareils Amazon" },
    { icon: Smartphone, name: "Smartphone", detail: "Android et iPhone" },
    { icon: Monitor, name: "Ordinateur", detail: "PC et ordinateur portable" },
];

export default function FreeTrial() {
    const [openFaq, setOpenFaq] = useState(0);

    useEffect(() => {
        document.title =
            "Essai IPTV Gratuit 24h en France | Abonnement IPTV";

        let description = document.querySelector(
            'meta[name="description"]'
        );

        if (!description) {
            description = document.createElement("meta");
            description.name = "description";
            document.head.appendChild(description);
        }

        description.content =
            "Testez notre abonnement IPTV en France avec un essai de 24h. Découvrez les chaînes, films, séries et la compatibilité avec vos appareils.";

        let canonical = document.querySelector(
            'link[rel="canonical"]'
        );

        if (!canonical) {
            canonical = document.createElement("link");
            canonical.rel = "canonical";
            document.head.appendChild(canonical);
        }

        canonical.href = "https://serviceiptv.ca/free-trial";
    }, []);

    return (


        <>
        
         <Seo
                title="🇫🇷 Abonnement IPTV France 2026 - Essai Gratuit 24h"
                description="Fournisseur IPTV #1 en France. SERVICE IPTV offre 10,000+ chaînes HD/4K, 120,000+ films/séries, streaming sans buffering. Support 24/7 en français. Essai gratuit 24h. Inscription rapide."
                url="https://abonnement-iptvfr.fr/free-trial"
                image="https://res.cloudinary.com/daopsqlfw/image/upload/v1779705752/IPTV1_po1clb.png"
              
              />
        
        <main className="min-h-screen bg-[#080B12] text-white overflow-hidden">

            {/* HERO */}
            <section className="relative px-5 pt-20 pb-24 md:pt-28 md:pb-32">
                <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_rgba(245,158,11,0.15),_transparent_45%)]" />

                <div className="absolute top-20 left-0 w-72 h-72 bg-amber-500/10 blur-[120px] rounded-full" />

                <div className="relative max-w-7xl mx-auto grid lg:grid-cols-2 gap-14 items-center">

                    <div>
                        <div className="inline-flex items-center gap-2 rounded-full border border-amber-500/30 bg-amber-500/10 px-4 py-2 text-sm text-amber-400 mb-7">
                            <Clock size={16} />
                            Essai disponible pendant 24 heures
                        </div>

                        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight tracking-tight">
                            Essai IPTV Gratuit en France :
                            <span className="block text-blue-600 mt-2">
                                Testez avant de choisir
                            </span> 
                        </h1>

                        <p className="mt-7 text-gray-400 text-lg leading-8 max-w-xl">
                            Vous recherchez un{" "}
                            <strong className="text-white">
                                abonnement IPTV en France
                            </strong>{" "}
                            et souhaitez découvrir le service avant de souscrire ?
                            Profitez de notre période d'essai de 24 heures pour tester
                            les fonctionnalités, la qualité de diffusion et la
                            compatibilité avec vos appareils.
                        </p>

                        <div className="flex flex-col sm:flex-row gap-4 mt-9">
                            <button
                                onClick={() =>
                                    window.open("https://wa.me/447308508638")
                                }
                                className="inline-flex items-center justify-center gap-2 rounded-xl border-2 border-blue-600 bg-white px-6 py-3.5 font-bold text-blue-600 transition-all duration-300 hover:-translate-y-1 hover:border-red-600 hover:bg-gradient-to-r hover:from-blue-600 hover:to-red-600 hover:text-white"
                            >
                                <MessageCircle size={20} />
                                Demander mon essai IPTV                  </button>

                            <Link
                                to="/pricing"
                                className="inline-flex items-center justify-center gap-2 border border-white/15 hover:border-amber-400/60 px-7 py-4 rounded-xl font-semibold transition"
                            >
                                Voir les abonnements
                            </Link>
                        </div>

                        <div className="flex flex-wrap gap-5 mt-9 text-sm text-gray-400">
                            <span className="flex items-center gap-2">
                                <CheckCircle2 className="text-blue-600" size={17} />
                                Test de 24 heures
                            </span>
                            <span className="flex items-center gap-2">
                                <CheckCircle2 className="text-blue-600" size={17} />
                                Plusieurs appareils
                            </span>
                        </div>
                    </div>

                    {/* HERO CARD */}
                    <div className="relative">
                        <div className="absolute inset-0 bg-amber-500/10 blur-3xl rounded-full" />

                        <div className="relative bg-[#111722] border border-white/10 rounded-3xl p-7 md:p-10 shadow-2xl">
                            <div className="flex items-center justify-between mb-9">
                                <div>
                                    <p className="text-gray-400 text-sm">
                                        Votre période de découverte
                                    </p>
                                    <h2 className="text-2xl font-bold mt-2">
                                        IPTV Test 24h
                                    </h2>
                                </div>

                                <div className="w-14 h-14 rounded-2xl bg-amber-500/15 flex items-center justify-center">
                                    <Play className="text-blue-600" size={27} />
                                </div>
                            </div>

                            <div className="rounded-2xl bg-gradient-to-br from-blue-600 to-orange-600 p-7 text-black">
                                <p className="font-semibold text-sm opacity-80">
                                    PÉRIODE D'ESSAI
                                </p>

                                <div className="flex items-end gap-3 mt-2">
                                    <span className="text-6xl font-black">24</span>
                                    <span className="text-2xl font-bold mb-2">HEURES</span>
                                </div>

                                <p className="mt-3 text-sm font-medium opacity-80">
                                    Découvrez les fonctionnalités du service.
                                </p>
                            </div>

                            <div className="mt-8 space-y-5">
                                {[
                                    "Découverte des chaînes disponibles",
                                    "Test des contenus à la demande",
                                    "Vérification de vos appareils",
                                    "Découverte de l'interface",
                                ].map((item, index) => (
                                    <div key={index} className="flex gap-3 items-center">
                                        <CheckCircle2
                                            size={19}
                                            className="text-blue-600 shrink-0"
                                        />
                                        <span className="text-gray-300 text-sm">{item}</span>
                                    </div>
                                ))}
                            </div>

                            <Link
                                to="/contact"
                                className="flex items-center justify-center gap-2 w-full mt-9 py-4 rounded-xl bg-white text-black font-bold hover:bg-amber-400 transition"
                            >
                                Commencer mon essai
                                <ArrowRight size={18} />
                            </Link>
                        </div>
                    </div>

                </div>
            </section>

            {/* FEATURES */}
            <section className="px-5 py-24 bg-[#0D121C]">
                <div className="max-w-7xl mx-auto">

                    <div className="text-center max-w-3xl mx-auto">
                        <span className="text-blue-600 uppercase tracking-[0.2em] text-xs font-bold">
                            Découvrez le service
                        </span>

                        <h2 className="text-3xl md:text-4xl font-bold mt-4">
                            Pourquoi tester notre abonnement IPTV ?
                        </h2>

                        <p className="text-gray-400 mt-5 leading-7">
                            Avant de choisir un abonnement IPTV en France, prenez
                            le temps de découvrir les fonctionnalités et de vérifier
                            si le service correspond à vos attentes.
                        </p>
                    </div>

                    <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-14">
                        {features.map((feature, index) => {
                            const Icon = feature.icon;

                            return (
                                <div
                                    key={index}
                                    className="group bg-[#151C28] border border-white/5 hover:border-amber-500/40 rounded-2xl p-7 transition duration-300"
                                >
                                    <div className="w-14 h-14 rounded-xl bg-amber-500/10 flex items-center justify-center group-hover:bg-amber-500/20 transition">
                                        <Icon className="text-blue-600" size={26} />
                                    </div>

                                    <h3 className="font-bold text-lg mt-6">
                                        {feature.title}
                                    </h3>

                                    <p className="text-gray-400 text-sm leading-7 mt-3">
                                        {feature.description}
                                    </p>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>

            {/* HOW IT WORKS */}
            <section className="px-5 py-24">
                <div className="max-w-7xl mx-auto">

                    <div className="text-center max-w-2xl mx-auto">
                        <span className="text-amber-400 uppercase tracking-[0.2em] text-xs font-bold">
                            Procédure simple
                        </span>

                        <h2 className="text-3xl md:text-4xl font-bold mt-4">
                            Comment obtenir votre essai IPTV gratuit ?
                        </h2>

                        <p className="text-gray-400 mt-5 leading-7">
                            Suivez ces quatre étapes pour découvrir votre service IPTV
                            pendant 24 heures.
                        </p>
                    </div>

                    <div className="grid md:grid-cols-4 gap-6 mt-14">
                        {[
                            {
                                number: "01",
                                title: "Contactez-nous",
                                text: "Envoyez une demande d'essai en indiquant votre appareil.",
                            },
                            {
                                number: "02",
                                title: "Recevez vos accès",
                                text: "Notre équipe vous communique les informations nécessaires.",
                            },
                            {
                                number: "03",
                                title: "Configurez votre application",
                                text: "Utilisez une application compatible avec votre appareil.",
                            },
                            {
                                number: "04",
                                title: "Testez le service",
                                text: "Découvrez les fonctionnalités disponibles pendant 24 heures.",
                            },
                        ].map((step) => (
                            <div
                                key={step.number}
                                className="relative rounded-2xl bg-[#111722] border border-white/10 p-7"
                            >
                                <span className="text-5xl font-black text-amber-500/20">
                                    {step.number}
                                </span>

                                <h3 className="text-lg font-bold mt-5">
                                    {step.title}
                                </h3>

                                <p className="text-gray-400 text-sm leading-7 mt-3">
                                    {step.text}
                                </p>
                            </div>
                        ))}
                    </div>

                    <div className="text-center mt-12">
                        <button
                            onClick={() =>
                                window.open("https://wa.me/447308508638")
                            }
                            className="inline-flex items-center justify-center gap-2 rounded-xl border-2 border-blue-600 bg-white px-6 py-3.5 font-bold text-blue-600 transition-all duration-300 hover:-translate-y-1 hover:border-red-600 hover:bg-gradient-to-r hover:from-blue-600 hover:to-red-600 hover:text-white"
                        >
                            <MessageCircle size={20} />
                            Demander mon essai IPTV                  </button>
                    </div>
                </div>
            </section>

            {/* DEVICES */}
            <section className="px-5 py-24 bg-[#0D121C]">
                <div className="max-w-7xl mx-auto">

                    <div className="text-center max-w-2xl mx-auto">
                        <span className="text-amber-400 uppercase tracking-[0.2em] text-xs font-bold">
                            Compatibilité
                        </span>

                        <h2 className="text-3xl md:text-4xl font-bold mt-4">
                            Testez IPTV sur vos appareils préférés
                        </h2>

                        <p className="text-gray-400 mt-5 leading-7">
                            Découvrez les possibilités d'utilisation sur différents
                            équipements compatibles.
                        </p>
                    </div>

                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-5 mt-14">
                        {devices.map((device, index) => {
                            const Icon = device.icon;

                            return (
                                <div
                                    key={index}
                                    className="text-center p-7 bg-[#151C28] border border-white/5 rounded-2xl hover:border-amber-500/40 transition"
                                >
                                    <Icon
                                        size={34}
                                        className="mx-auto text-amber-400"
                                    />
                                    <h3 className="font-bold mt-5">{device.name}</h3>
                                    <p className="text-xs text-gray-500 mt-2">
                                        {device.detail}
                                    </p>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>

            {/* SUBSCRIPTION GUIDE */}
            <section className="px-5 py-24">
                <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-12 items-center">

                    <div>
                        <span className="text-amber-400 uppercase tracking-[0.2em] text-xs font-bold">
                            Bien choisir
                        </span>

                        <h2 className="text-3xl md:text-4xl font-bold mt-4 leading-tight">
                            Comment choisir un abonnement IPTV en France ?
                        </h2>

                        <p className="text-gray-400 mt-5 leading-8">
                            Le choix d'un abonnement IPTV dépend de vos habitudes,
                            de vos appareils et des fonctionnalités que vous recherchez.
                            La période d'essai vous permet de mieux évaluer le service
                            avant de vous engager.
                        </p>

                        <Link
                            to="/pricing"
                            className="inline-flex items-center gap-2 text-amber-400 font-bold mt-7 hover:gap-4 transition-all"
                        >
                            Comparer les abonnements
                            <ArrowRight size={18} />
                        </Link>
                    </div>

                    <div className="bg-[#111722] border border-white/10 rounded-3xl p-8">
                        <h3 className="font-bold text-xl mb-7">
                            Les critères à vérifier
                        </h3>

                        {[
                            "Les chaînes et contenus proposés",
                            "La compatibilité avec vos appareils",
                            "La qualité et la stabilité du streaming",
                            "Les fonctionnalités incluses",
                            "Le prix et la durée de l'abonnement",
                            "La qualité du support client",
                            "Les autorisations de diffusion des contenus",
                        ].map((item, index) => (
                            <div
                                key={index}
                                className="flex gap-3 items-center py-3 border-b border-white/5 last:border-0"
                            >
                                <CheckCircle2
                                    size={18}
                                    className="text-amber-400 shrink-0"
                                />
                                <span className="text-gray-300 text-sm">{item}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* FAQ */}
            <section className="px-5 py-24 bg-[#0D121C]">
                <div className="max-w-4xl mx-auto">

                    <div className="text-center mb-14">
                        <span className="text-amber-400 uppercase tracking-[0.2em] text-xs font-bold">
                            FAQ
                        </span>

                        <h2 className="text-3xl md:text-4xl font-bold mt-4">
                            Questions fréquentes sur l'essai IPTV
                        </h2>

                        <p className="text-gray-400 mt-4">
                            Retrouvez les réponses aux questions les plus courantes
                            concernant notre essai IPTV en France.
                        </p>
                    </div>

                    <div className="space-y-4">
                        {faqs.map((faq, index) => {
                            const isOpen = openFaq === index;

                            return (
                                <div
                                    key={index}
                                    className="bg-[#151C28] border border-white/10 rounded-xl overflow-hidden"
                                >
                                    <button
                                        type="button"
                                        onClick={() =>
                                            setOpenFaq(isOpen ? -1 : index)
                                        }
                                        aria-expanded={isOpen}
                                        className="w-full flex items-center justify-between gap-5 text-left p-6 hover:text-amber-400 transition"
                                    >
                                        <span className="font-semibold">
                                            {faq.question}
                                        </span>

                                        <ChevronDown
                                            size={20}
                                            className={`shrink-0 transition-transform ${isOpen ? "rotate-180 text-amber-400" : ""
                                                }`}
                                        />
                                    </button>

                                    {isOpen && (
                                        <div className="px-6 pb-6 text-gray-400 text-sm leading-7">
                                            {faq.answer}
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>

            {/* FINAL CTA */}
            <section className="px-5 py-24">
                <div className="max-w-5xl mx-auto relative overflow-hidden rounded-3xl bg-gradient-to-br from-blue-600 to-orange-600 p-9 md:p-16 text-center text-black">

                    <div className="absolute -top-20 -right-20 w-64 h-64 bg-white/10 rounded-full blur-3xl" />

                    <div className="relative">
                        <div className="w-16 h-16 bg-black/10 rounded-2xl flex items-center justify-center mx-auto">
                            <Headphones size={32} />
                        </div>

                        <h2 className="text-3xl md:text-5xl font-black mt-7 leading-tight">
                            Prêt à découvrir votre essai IPTV ?
                        </h2>

                        <p className="max-w-2xl mx-auto mt-5 text-black/75 leading-8">
                            Découvrez notre service pendant 24 heures, testez les
                            fonctionnalités disponibles et prenez le temps de choisir
                            votre formule d'abonnement IPTV.
                        </p>

                        <button
                            onClick={() =>
                                window.open("https://wa.me/447308508638")
                            }
                            className="inline-flex items-center justify-center gap-2 rounded-xl border-2 border-blue-600 bg-white px-6 py-3.5 font-bold text-blue-600 transition-all duration-300 hover:-translate-y-1 hover:border-red-600 hover:bg-gradient-to-r hover:from-blue-600 hover:to-red-600 hover:text-white"
                        >
                            <MessageCircle size={20} />
                            Demander mon essai gratuit                  </button>

                        <p className="mt-5 text-sm text-black/65">
                            Service proposé sous réserve des conditions d'accès.
                        </p>
                    </div>
                </div>
            </section>

        </main>
        </>
    );
}
